import {doApi} from "./core";

export function resetPassword(language, params) {
    return doApi(language, params, "/be/reset_password");
}

export function getReserveDetails(language, params) {
    return doApi(language, params, "/be/get_reserve_details");
}
